import React, { FunctionComponent } from "react";
import Text from "../common/text";
import { theme } from "../../themes/global";
import styled from "@emotion/styled";

export const Error = styled(Text)`
  &::before {
    content: "!";
    display: inline-block;
    padding: 0;
    color: ${theme.color.white};
    text-align: center;
    font-size: 8px;
    line-height: 14px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: ${theme.color.warning};
    margin-right: 2px;
  }
`;

export const Wrapper = styled("div")`
  padding: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
`;

export const Label = styled("label")`
  width: 100%;
  flex-wrap: wrap;
  display: flex;
  margin-top: 15px;
  padding-bottom: 4px;
`;
